import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { numberCheck } from "@common/NumberCheck"; // numberCheck 함수 import
import styled from "styled-components";

const StyledLink = styled.a`
  color: #7e7e7e;
  font-size: 14px;
  font-weight: 400;
  padding: 0 10px;
`;
const StyledTitle = styled.span`
  color: #7e7e7e;
  font-size: 14px;
  font-weight: 400;
  padding: 0 10px;
  &::before {
    content: none !important;
    display: none !important;
  }
`;

const Breadcrumb2 = ({ categoryName, categoryHash, hash, ename }) => {
  const router = useRouter();

  // 해시가 숫자인지 확인 (페이지 번호인 경우)
  const isNumericHash = hash && numberCheck(hash);
  const isNumericRouterHash =
    router.query.hash && numberCheck(router.query.hash);

  // 표시할 해시 결정 (숫자인 경우 표시하지 않음)
  const displayHash = isNumericHash ? null : hash;
  const displayRouterHash = isNumericRouterHash ? null : router.query.hash;

  return (
    <>
      {categoryHash && categoryName && (
        <div className="page-header mb-30" style={{ wordBreak: "keep-all" }}>
          <div className="row">
            <div className="">
              <h3 className="mb-15 text-capitalize">{categoryName}</h3>

              {!router.query.search &&
                !router.query.garo &&
                !router.query.sero &&
                !router.query.high &&
                !router.query.erange && (
                  <div className="breadcrumb">
                    <StyledLink href="/">
                      <a rel="nofollow">
                        <i className="fi-rs-home mr-5"></i>홈
                      </a>
                    </StyledLink>
                    &gt;
                    <StyledLink href="/products/">
                      <a>상품구매</a>
                    </StyledLink>
                    {hash ? (
                      <>
                        &gt;
                        <StyledLink href={`/products/${ename}/`}>
                          <a>{categoryName}</a>
                        </StyledLink>
                      </>
                    ) : (
                      <>
                        &gt;
                        <StyledTitle>{categoryName}</StyledTitle>
                      </>
                    )}
                    {(displayHash || displayRouterHash) && (
                      <>
                        &gt;
                        <StyledTitle>
                          {displayHash || displayRouterHash}
                        </StyledTitle>
                      </>
                    )}
                  </div>
                )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Breadcrumb2;
